<template>
  <div
    class="instrument-card"
    :class="{ 'locale-zh-CN': isZhLocale }"
    @click="$emit('click', item)"
  >
    <div class="cover-wrap">
      <img class="cover" :src="coverSrc" alt="" @error="onCoverError" />
    </div>
    <div class="body">
      <h3 class="title" :title="item.name">{{ item.name || '' }}</h3>
      <div class="category" :title="displayCategory">{{ displayCategory }}</div>
      <div class="price-row">
        <span class="price-label">{{ labels.priceLabel }}</span>
        <span class="price-value">{{ displayPrice }}</span>
      </div>
      <div class="unit-row">
        <img v-if="unitIcon" class="unit-ico" :src="unitIcon" alt="" @error="onImgError" />
        <span class="unit-text" :title="displayUnit">{{ displayUnit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getInstrumentsNewConfig } from '@/config/instrumentsNewConfig'
import { getSafeImage, handleImgError } from '@/utils/imageFallback'
import { getCurrentLocale } from '@/utils/i18nText'

const EMPTY_TIP = '待接口提供'

export default {
  name: 'InstrumentCard',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      coverFailed: false
    }
  },
  computed: {
    isZhLocale() {
      return getCurrentLocale() === 'zh-CN'
    },
    config() {
      return getInstrumentsNewConfig(getCurrentLocale())
    },
    labels() {
      return this.config.card || {}
    },
    emptyTip() {
      return this.labels.emptyTip || EMPTY_TIP
    },
    fallbackCover() {
      return getSafeImage(this.labels.coverFallback)
    },
    unitIcon() {
      return getSafeImage(this.labels.unitIcon)
    },
    coverSrc() {
      if (this.coverFailed) return this.fallbackCover
      const src = getSafeImage(this.item.image)
      return src || this.fallbackCover
    },
    displayCategory() {
      return this.normalizeText(this.item.category)
    },
    displayPrice() {
      const price = this.item.price
      if (price === undefined || price === null || price === '') {
        return this.labels.priceDefault || '面议'
      }
      const text = this.normalizeText(price)
      return text || (this.labels.priceDefault || '面议')
    },
    displayUnit() {
      return this.normalizeText(this.item.unit)
    }
  },
  watch: {
    'item.image'() {
      this.coverFailed = false
    },
    'item.id'() {
      this.coverFailed = false
    }
  },
  methods: {
    normalizeText(val) {
      const text = String(val == null ? '' : val).trim()
      if (!text || text === this.emptyTip || text === EMPTY_TIP) return ''
      return text
    },
    onCoverError(e) {
      this.coverFailed = true
      handleImgError(e)
    },
    onImgError(e) {
      handleImgError(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.instrument-card {
  display: flex;
  align-items: stretch;
  gap: 14px;
  min-height: 132px;
  padding: 14px;
  background: #fff;
  border: 1px solid #ebe6d8;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 6px 16px rgba(160, 144, 60, 0.12);

    .title {
      color: #8c7b21;
    }
  }
}

.cover-wrap {
  flex-shrink: 0;
  width: 104px;
  height: 104px;
  background: #f5f5f5;
  border-radius: 2px;
  overflow: hidden;
}

.cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2px 0;
}

.title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #222;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category {
  margin-top: 6px;
  font-size: 13px;
  color: #999;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.price-row {
  margin-top: 10px;
  font-size: 13px;
  line-height: 1.3;
}

.price-label {
  color: #a0903c;
  font-weight: 600;
}

.price-value {
  color: #a0903c;
  font-weight: 600;
}

.unit-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  min-width: 0;
}

.unit-ico {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  object-fit: contain;
}

.unit-text {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.locale-zh-CN {
  .title {
    font-size: 18px;
  }

  .category,
  .price-row,
  .unit-text {
    font-size: 15px;
  }

  .unit-ico {
    width: 16px;
    height: 16px;
  }

  .cover-wrap {
    width: 116px;
    height: 116px;
  }
}
</style>
